import 'react-native-get-random-values';

import { GiftedAvatar, MessageText, Time, utils } from 'react-native-gifted-chat';
import { LayoutChangeEvent, Platform, StyleSheet, View, ViewProps } from 'react-native';
import React, { memo } from 'react';

import MarkdownText from './MarkdownText';
import { useTheme } from '@ui-kitten/components';

interface IChatTextMessageProps extends ViewProps {
  data: any;
  setBubbleWidth: (messageId: string, width: number) => void;
  setBubbleHeight: (messageId: string, width: number) => void;
}

const ChatTextMessage = (props: IChatTextMessageProps) => {
  const th = useTheme();
  const { renderAvatarOnTop, position, currentMessage, previousMessage, nextMessage } = props.data;
  const markdownStyles = StyleSheet.create({
    view: {
      marginHorizontal: 10,
      marginVertical: Platform.OS === 'web' ? (position == 'left' ? 12 : 10) : position == 'left' ? 2 : 0
    },
    text: {
      color: props.data.position === 'right' ? 'white' : th['text-basic-color']
    }
  });

  const avatarImageStyles = {
    height: 24,
    width: 24,
    borderRadius: 12,
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  };

  const timeStyles: any = {
    left: StyleSheet.create({
      container: {
        position: 'absolute',
        alignSelf: 'flex-start',
        height: 40,
        bottom: -30,
        width: 64
      }
    }),
    right: StyleSheet.create({
      container: {
        alignSelf: 'flex-end',
        position: 'absolute',
        bottom: -30,
        height: 40,
        width: 64
      }
    })
  };

  // calculate width of bubble
  const onLayout = (event: LayoutChangeEvent, messageId: string) => {
    const { width, height } = event.nativeEvent.layout;
    props.setBubbleWidth(messageId, width);
    props.setBubbleHeight(messageId, height);
  };

  const messageToCompare = renderAvatarOnTop ? previousMessage : nextMessage;
  const isShowDate = !(
    currentMessage &&
    messageToCompare &&
    utils.isSameUser(currentMessage, messageToCompare) &&
    utils.isSameDay(currentMessage, messageToCompare)
  );

  if (props?.data?.currentMessage?.text && props.data.currentMessage.text.length > 0) {
    return (
      <View
        style={{ backgroundColor: 'transparent' }}
        accessible={true}
        accessibilityLabel={`${position} message`}
        testID={`message-${position}`}>
        <View onLayout={(event) => onLayout(event, props.data.currentMessage._id)}>
          <MarkdownText styles={markdownStyles}>{props.data.currentMessage.text}</MarkdownText>
        </View>
        {isShowDate === true && position === 'left' && (
          <View style={{ position: 'absolute', left: -34, bottom: -3 }}>
            <GiftedAvatar {...props.data} user={props.data.currentMessage.user} avatarStyle={avatarImageStyles} />
          </View>
        )}

        {isShowDate === true && (
          <View style={[timeStyles[position].container, { paddingBottom: 6 }]}>
            <Time
              {...props.data}
              timeTextStyle={{
                left: {
                  textAlign: 'left',
                  marginTop: 14,
                  fontSize: 10,
                  color: th['text-hint-color']
                },
                right: {
                  textAlign: 'right',
                  marginTop: 14,
                  fontSize: 10,
                  color: th['text-hint-color']
                }
              }}
            />
          </View>
        )}
      </View>
    );
  }
  return <MessageText {...props.data} />;
};

export default memo(ChatTextMessage);
